export default __webpack_public_path__ + "static/media/linkedinIconCircle.a525f7c3.svg";